import { FC } from 'react'
import { Button, Box, Flex } from '@sequencehq/core-components'
import {
  BorderRadius6,
  GreyGrey10,
  GreyGrey70,
  GreyGrey80,
  Primary13SemiBold,
  Primary13Regular,
  Spacing8
} from '@sequencehq/core-components'
import { useStripeRetryPaymentWidget } from './useStripeRetryPaymentWidget'

const CONTENT = {
  TITLE: 'Payment retry',
  BUTTON_TEXT: 'Retry payment',
  DESCRIPTION:
    'Retry collecting payment for this invoice. If the payment has already been collected successfully, no duplicate charge will be created.'
} as const

interface StripeRetryPaymentWidgetProps {
  invoiceId: string
  disabled?: boolean
}

export const StripeRetryPaymentWidget: FC<
  StripeRetryPaymentWidgetProps
> = props => {
  const { isLoading, retryPayment } = useStripeRetryPaymentWidget({
    invoiceId: props.invoiceId
  })

  return (
    <Flex flexDirection="column" gap={Spacing8}>
      <Box {...Primary13SemiBold} color={GreyGrey80}>
        {CONTENT.TITLE}
      </Box>
      <Box
        borderRadius={BorderRadius6}
        backgroundColor={GreyGrey10}
        padding={Spacing8}
      >
        <Button
          variant="secondary"
          disabled={props.disabled}
          onClick={() => void retryPayment()}
          data-testid="stripe.inspector.content.retryPayment"
          fullWidth
        >
          {CONTENT.BUTTON_TEXT}
        </Button>
      </Box>
      <Box {...Primary13Regular} color={GreyGrey70}>
        {CONTENT.DESCRIPTION}
      </Box>
    </Flex>
  )
}
